/**
 * Searches products for a valid Marvel trial account.
 *
 */
define('lib/models/account/is-marvel-account',['require','lodash'],function (require) {
    var _ = require('lodash');

    return function (products) {
        var requiredProducts = ['GoToMeeting', 'GoToMeetingFree'];
        var isMarvel;

        var productNames = _.pluck(products, 'product');
        var intersection = _.intersection(productNames, requiredProducts);

        isMarvel = intersection.length === 2;

        return isMarvel;
    };
});

